// Author: Ozy
// Cart Custom Pricing Calculator
// Updates line item prices and cart total to include custom options pricing

class CartCustomPricing {
  constructor() {
    this.init();
  }

  init() {
    // Wait for cart to be loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.updateCartPrices());
    } else {
      this.updateCartPrices();
    }

    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      setTimeout(() => this.updateCartPrices(), 100);
    });
  }

  async updateCartPrices() {
    try {
      // Fetch current cart
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      
      const cart = await response.json();
      
      let totalOptionsPrice = 0;
      
      // Update each line item
      cart.items.forEach((item, index) => {
        let itemOptionsPrice = 0;
        
        if (item.properties) {
          for (const [key, value] of Object.entries(item.properties)) {
            // Look for price in property values like "+$10.00"
            if (typeof value === 'string') {
              const priceMatch = value.match(/\+\s*\$\s*(\d+(?:\.\d{1,2})?)/);
              if (priceMatch) {
                const price = parseFloat(priceMatch[1]);
                if (!isNaN(price) && price > 0) {
                  itemOptionsPrice += price;
                }
              }
            }
          }
        }

        if (itemOptionsPrice > 0) {
          // Update line item price display
          this.updateLineItemPrice(index + 1, item.final_line_price + (itemOptionsPrice * item.quantity * 100));
          totalOptionsPrice += itemOptionsPrice * item.quantity * 100;
        }
      });

      // Update cart total
      if (totalOptionsPrice > 0) {
        const newTotal = cart.total_price + totalOptionsPrice;
        this.updateTotalDisplay(newTotal);
      }

    } catch (error) {
      console.error('Cart pricing calculation error:', error);
    }
  }

  updateLineItemPrice(itemIndex, newPriceCents) {
    // Find all price elements for this line item (mobile + desktop)
    const itemId = `CartItem-${itemIndex}`;
    const itemElement = document.getElementById(itemId);
    
    if (!itemElement) {
      console.log(`[Cart Pricing] Could not find cart item ${itemId}`);
      return;
    }

    // Find all price display elements (handles both discounted and regular prices)
    const priceElements = itemElement.querySelectorAll('.cart-item__totals .price.price--end');
    
    if (priceElements.length === 0) {
      console.log(`[Cart Pricing] No price elements found for ${itemId}`);
      return;
    }

    const formattedPrice = this.formatMoney(newPriceCents);
    
    // Update all price elements (there may be 2: one for mobile, one for desktop)
    priceElements.forEach(priceElement => {
      priceElement.textContent = formattedPrice;
      priceElement.setAttribute('data-custom-price', 'true');
    });
    
    console.log(`[Cart Pricing] Updated ${priceElements.length} price element(s) for ${itemId} to ${formattedPrice}`);
  }

  updateTotalDisplay(newTotal) {
    // Find the total price element
    const totalElement = document.querySelector('.totals__total-value');
    if (!totalElement) return;

    // Format the new total
    const formatted = this.formatMoney(newTotal);
    totalElement.textContent = formatted;
  }

  formatMoney(cents) {
    // Basic money formatting - adjust for your currency
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
}

// Auto-initialize
new CartCustomPricing();

